import {Pipe, PipeTransform} from '@angular/core';
import {IconSize} from '../../bfa-api/models/icon-size';
import {IconService} from '../../services/icon/icon.service';
import {STATIC_CONFIGS} from '../../../configs/static.config';

@Pipe({
    name: 'apiIconUrl',
    pure: true
})
export class ApiIconUrlPipe implements PipeTransform {
    public transform(iconId: string | null | undefined, iconSize: IconSize = STATIC_CONFIGS.ui.defaultIconFetchSize, absolutePath: boolean = false): string | null | undefined {
        if (!iconId) {
            return iconId;
        }

        if (absolutePath) {
            return IconService.getAbsoluteBfaIconUrl(iconId, iconSize);
        } else {
            return IconService.getIconUrl(iconId, iconSize);
        }
    }
}
